import { Fragment } from 'react'
import { MDBFooter } from 'mdb-react-ui-kit'
import { Link } from 'react-router-dom'
import classes from './HomepageFooter.module.css'

import germanStartups from '../assets/img/deutsche-startups.svg'

const vendors = [
  {
    name: 'aldi talk',
    link: '/anbieter/aldi-talk',
  },
  {
    name: 'bigpoint',
    link: '/anbieter/bigpoint',
  },
  {
    name: 'bild mobil',
    link: '/anbieter/bild-mobil',
  },
  {
    name: 'blau',
    link: '/anbieter/blau',
  },
  {
    name: 'congstar',
    link: '/anbieter/congstar',
  },
  {
    name: 'deezer',
    link: '/anbieter/deezer',
  },
  {
    name: 'e-plus',
    link: '/anbieter/e-plus',
  },
  {
    name: 'fonic',
    link: '/anbieter/fonic',
  },
  {
    name: 'google play',
    link: '/anbieter/google-play',
  },
  {
    name: 'klarmobil',
    link: '/anbieter/klarmobil',
  },
  {
    name: 'lebara',
    link: '/anbieter/lebara',
  },
  {
    name: 'lycamobile',
    link: '/anbieter/lycamobile',
  },
  {
    name: 'mobi',
    link: '/anbieter/mobi',
  },
  {
    name: 'netflix',
    link: '/anbieter/netflix',
  },
  {
    name: 'nintendo',
    link: '/anbieter/nintendo',
  },
  {
    name: 'o2',
    link: '/anbieter/o2',
  },
  {
    name: 'ortel',
    link: '/anbieter/ortel',
  },
  {
    name: 'otelo',
    link: '/anbieter/otelo',
  },
  {
    name: 'paysafecard',
    link: '/anbieter/paysafecard',
  },
  {
    name: 'playstation plus',
    link: '/anbieter/playstation-plus',
  },
  {
    name: 'sony playstatiom',
    link: '/anbieter/sony-playstatiom',
  },
  {
    name: 'spotify',
    link: '/anbieter/spotify',
  },
  {
    name: 'steam',
    link: '/anbieter/steam',
  },
  {
    name: 'telekom',
    link: '/anbieter/telekom',
  },
  {
    name: 'turlcell',
    link: '/anbieter/turlcell',
  },
  {
    name: 'vodafone',
    link: '/anbieter/vodafone',
  },
  {
    name: 'xbox',
    link: '/anbieter/xbox',
  },
  {
    name: 'yourfone',
    link: '/anbieter/yourfone',
  },
  {
    name: 'zalando',
    link: '/anbieter/zalando',
  },
]

const favoriteProducts = [
  {
    name: 'Paysafecard 50 Euro',
    price: '50,00 €',
    link: '/produkt/paysafecard-50-euro',
  },
  {
    name: 'Paysafecard 20 Euro',
    price: '20,00 €',
    link: '/produkt/paysafecard-20-euro',
  },
  {
    name: 'Paysafecard 100 Euro',
    price: '100,00 €',
    link: '/produkt/paysafecard-100-euro',
  },
  {
    name: 'Paysafecard 10 Euro',
    price: '10,00 €',
    link: '/produkt/paysafecard-10-euro',
  },
  {
    name: 'Paysafecard 30 Euro',
    price: '30,00 €',
    link: '/produkt/paysafecard-30-euro',
  },
  {
    name: '25 Euro Amazon Gutschein',
    price: '25,00 €',
    link: '/produkt/amazon-gutschein-25-euro',
  },
  {
    name: 'Paysafecard 15 Euro',
    price: '15,00 €',
    link: '/produkt/paysafecard-15-euro',
  },
  {
    name: 'Paysafecard 25 Euro',
    price: '25,00 €',
    link: '/produkt/paysafecard-25-euro',
  },
  {
    name: '50 Euro Google Play Gutschein',
    price: '50,00 €',
    link: '/produkt/google-play-gutschein-50-euro',
  },
]

function HomepageFooter() {
  return (
    <Fragment>
      <MDBFooter className={`${classes.mainFooter} bg-pays-dark font-white`}>
        <div className='container'>
          <div className='row'>
            <div className={`col-lg-3 col-sm-6 ${classes.mainFooterBox}`}>
              <p className={classes.title}>Service</p>
              <p className='d-flex'>
                E-Mail:&nbsp;{' '}
                <a href='mailto:support@pays.de'>support@pays.de</a>
              </p>
              <p>
                Sie erreichen unseren Service werktags von 08-18 Uhr und
                jederzeit per E-Mail.
              </p>
            </div>
            <div className={`col-lg-3 col-sm-6 ${classes.mainFooterBox}`}>
              <p className={classes.title}>Wichtige Informationen</p>
              {/* <Link to='/uber-uns'>Über uns</Link> */}
              <Link to='/'>Allgemeine Geschäftsbedinungen</Link>
              <a href='/docs/PAYS_Datenschutzerklaerung.pdf'>Datenschutz</a>
              <Link to='/widerrufsbelehrung'>Wiederrufsbelehrung</Link>
              <Link className='mb-5' to='/impressum'>
                Impressum
              </Link>
              <p className={classes.title}>Unsere Partner</p>
              <img src={germanStartups} alt='logo' className='py-3' />
            </div>
            <div className={`col-lg-3 col-sm-6 ${classes.mainFooterBox}`}>
              <p className={classes.title}>Produkt Schlagwörter</p>
              <div className='d-flex flex-wrap'>
                {vendors.map((vendor, index) => (
                  <Link className={classes.vendor} key={index} to={vendor.link}>
                    {vendor.name}
                  </Link>
                ))}
              </div>
            </div>
            <div className={`col-lg-3 col-sm-6 ${classes.mainFooterBox}`}>
              <p className={classes.title}>Beliebteste Produkte</p>
              <ul className={classes.favoriteProductsList}>
                {favoriteProducts.map((product, index) => (
                  <li key={index}>
                    <Link
                      to={product.link}
                      className={classes.favoriteProductLink}
                    >
                      {product.name}
                    </Link>
                    <span>{product.price}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className={`row ${classes.mainFooterRow}`}>
            <div className={`text-center ${classes.copyrightBox}`}>
              <p className='py-3'>
                Copyright &copy;{new Date().getFullYear()} Pays
              </p>
            </div>
            <div className={`col-sm-4 text-center ${classes.socialMedia}`}>
              {/* <a className='py-3' href='#'>
                <img src={facebook} aria-hidden='true' alt='facebook'></img>
              </a>
              <a className='py-3' href='#'>
              <img src={instagram} aria-hidden='true' alt='instagram'></img>
              </a>
              <a className='py-3' href='#'>
                <img src={twitter} aria-hidden='true' alt='twitter'></img>
              </a>
              <a className='py-3' href='#'>
              <img src={youtube} aria-hidden='true' alt='twitter'></img>
              </a> */}
            </div>
          </div>
        </div>
      </MDBFooter>
    </Fragment>
  )
}

export default HomepageFooter
